import React, { useContext, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaLock,
  FaCube,
  FaVirus,
  FaSpaceShuttle,
  FaRobot,
  FaGuitar,
  FaCrosshairs,
  // FaCamera,
  FaCode,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaSearchPlus
} from "react-icons/fa";
import Footer from "../components/Footer/Footer";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";
import classes from "./Game.module.css";

// Testi provvisori: da sostituire con quelli definitivi
const gamesData = [
  {
    id: 1,
    title: {
      it: "Virus Survivors",
      en: "Virus Survivors"
    },
    subtitle: {
      it: "Survivor Roguelite Arcade",
      en: "Arcade Survivor Roguelite"
    },
    tag: "Three.js / WebGL",
    icon: <FaVirus />,
    badge: {
      it: "Sviluppo 80%",
      en: "Development 80%"
    },
    version: "STATUS: 80%",
    image: "/assets/images/games/virus-survivors.jpg",
    imageBg: "#ffffff",
    description: {
      it: "Un antivirus in miniatura contro ondate infinite di virus, malware e trojan dentro un computer impazzito. Raccogli upgrade, combina armi e potenziamenti e sopravvivi il più a lungo possibile in partite brevi e frenetiche.",
      en: "A tiny antivirus against endless waves of viruses, malware and trojans inside a computer gone haywire. Collect upgrades, combine weapons and power-ups and survive as long as you can in short, frantic runs."
    },
    technologies: ["Three.js", "WebGL", "Wave System", "Upgrade Tree", "Web Audio API"],
    screenshots: []
  },
  {
    id: 2,
    title: {
      it: "Space Legacy",
      en: "Space Legacy"
    },
    subtitle: {
      it: "Shoot'em up spaziale",
      en: "Space shoot'em up"
    },
    tag: "Three.js / WebGL",
    icon: <FaSpaceShuttle />,
    badge: {
      it: "Sviluppo 50%",
      en: "Development 50%"
    },
    version: "STATUS: 50%",
    image: "/assets/images/games/space-legacy.jpg",
    imageBg: "#05070d",
    description: {
      it: "Un omaggio che prova a reinventare il classico Space Invaders: formazioni nemiche che cambiano strategia, boss a fasi, potenziamenti per la nave e una grafica low-poly 3D con lo spirito degli arcade anni '80.",
      en: "A tribute that tries to reinvent the classic Space Invaders: enemy formations that change strategy, multi-phase bosses, ship upgrades and low-poly 3D graphics with the spirit of '80s arcades."
    },
    technologies: ["Three.js", "WebGL", "Enemy AI Patterns", "Particle FX", "Chiptune Audio"],
    screenshots: []
  },
  {
    id: 3,
    title: {
      it: "ADAM-01: AI Wars",
      en: "ADAM-01: AI Wars"
    },
    subtitle: {
      it: "Mecha survivor 3D isometrico",
      en: "Isometric 3D mecha survivor"
    },
    tag: "Three.js / WebGL",
    icon: <FaRobot />,
    badge: {
      it: "Sviluppo 30%",
      en: "Development 30%"
    },
    version: "STATUS: 30%",
    image: "/assets/images/games/adam-01-ai-wars.jpg",
    imageBg: "#000000",
    description: {
      it: "Gioco 3D isometrico che porta le meccaniche di Vampire Survivors in un ambiente tridimensionale: pilota il mecha ADAM-01 contro orde di macchine ribelli, potenzia l'armamento a ogni livello e sfrutta il terreno a tuo vantaggio.",
      en: "Isometric 3D game that brings Vampire Survivors mechanics into a three-dimensional world: pilot the ADAM-01 mecha against hordes of rogue machines, upgrade your arsenal every level and use the terrain to your advantage."
    },
    technologies: ["Three.js", "Isometric Camera", "Horde AI", "Instanced Rendering", "Upgrade System"],
    screenshots: []
  },
  {
    id: 4,
    title: {
      it: "Guitar Blade",
      en: "Guitar Blade"
    },
    subtitle: {
      it: "Roguelike a stanze",
      en: "Room-based roguelike"
    },
    tag: "Three.js / WebGL",
    icon: <FaGuitar />,
    badge: {
      it: "Prototipo",
      en: "Prototype"
    },
    version: "STATUS: PROTOTYPE",
    image: "/assets/images/games/guitar-blade.jpg",
    imageBg: "#ffffff",
    description: {
      it: "Il protagonista è Riff, un metallaro armato della sua chitarra. Meccaniche alla The Binding of Isaac: stanze generate proceduralmente, oggetti che cambiano lo stile di gioco e boss da abbattere a colpi di assoli.",
      en: "The hero is Riff, a metalhead armed with his guitar. The Binding of Isaac-style mechanics: procedurally generated rooms, items that change your playstyle and bosses to take down with guitar solos."
    },
    technologies: ["Three.js", "Procedural Rooms", "Item Synergies", "Boss Patterns", "Web Audio API"],
    screenshots: []
  },
  {
    id: 5,
    title: {
      it: "Malfunction: AI Wars",
      en: "Malfunction: AI Wars"
    },
    subtitle: {
      it: "First person shooter",
      en: "First person shooter"
    },
    tag: "Three.js / WebGL",
    icon: <FaCrosshairs />,
    badge: {
      it: "Prototipo",
      en: "Prototype"
    },
    version: "STATUS: PROTOTYPE",
    image: "/assets/images/games/malfunction-ai.jpg",
    imageBg: "#ffffff",
    description: {
      it: "FPS in cui le intelligenze artificiali sono andate in tilt: robot domestici, droni e macchine impazzite invadono la città. Armi da potenziare, arene dinamiche e nemici con comportamenti sempre diversi.",
      en: "An FPS where artificial intelligences have gone haywire: household robots, drones and rogue machines invade the city. Upgradable weapons, dynamic arenas and enemies with ever-changing behaviours."
    },
    technologies: ["Three.js", "FPS Controller", "Enemy AI", "Physics", "Post-Processing"],
    screenshots: []
  }
];

const GamePage = () => {
  const { lang = "it" } = useContext(Context);
  const [text, setText] = useState("Games");
  const [text2, setText2] = useState("Side projects");
  const [activeLightbox, setActiveLightbox] = useState(null);

  useEffect(() => {
    setText("Games");
    setText2("Side projects");
  }, [lang]);

  // Gestione tastiera e blocco scroll per il Lightbox
  useEffect(() => {
    if (!activeLightbox) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setActiveLightbox(null);
      } else if (e.key === "ArrowRight") {
        setActiveLightbox((prev) => {
          if (!prev) return null;
          return {
            ...prev,
            currentIndex: (prev.currentIndex + 1) % prev.images.length
          };
        });
      } else if (e.key === "ArrowLeft") {
        setActiveLightbox((prev) => {
          if (!prev) return null;
          return {
            ...prev,
            currentIndex: (prev.currentIndex - 1 + prev.images.length) % prev.images.length
          };
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [activeLightbox]);

  const openGallery = (game, startIndex = 0) => {
    const images = [
      {
        id: "cover",
        type: "cover",
        badge: lang === "en" ? "Cover Art / Main" : "Cover / Poster Gioco",
        title: game.title[lang] || game.title.it,
        subtitle: game.subtitle[lang] || game.subtitle.it,
        src: game.image,
        version: game.version
      }
      /* Screenshot temporaneamente commentati, pronti per riattivazione successiva
      ...game.screenshots.map((s, idx) => ({
        id: `screen-${s.id}`,
        type: "screenshot",
        badge: `Screenshot 0${idx + 1}`,
        title: `${game.title[lang] || game.title.it} — ${s.title}`,
        subtitle: game.subtitle[lang] || game.subtitle.it,
        src: s.src
      }))
      */
    ];

    setActiveLightbox({
      gameTitle: game.title[lang] || game.title.it,
      images,
      currentIndex: Math.min(startIndex, images.length - 1)
    });
  };

  return (
    <>
      <title>Davide Balice - Games & Side Projects</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 0.6 }}
      >
        <OfficeTitle text={text} text2={text2} />

        <div className={classes.gamesContainer}>
          {/* Header Sezione */}
          <div className={classes.titleSection}>
            <div className={classes.badgeContainer}>
              <span className={classes.sideProjectBadge}>
                <span className={classes.pulseDot}></span>
                Side Project
              </span>
            </div>
            <h1 className={classes.mainHeading}>
              {lang === "en" ? "Game Development" : "Sviluppo Videogiochi"}
            </h1>
            <p className={classes.mainIntro}>
              {lang === "en"
                ? "Development of complete prototypes using Three.js, followed by evaluating the porting to Godot or Unity."
                : "Sviluppo prototipi completi con Three.js, successivamente si valuta il porting su Godot o Unity."}
            </p>
            <div className={classes.subHeading}>
              <span className={`${classes.statusPill} ${classes.statusDev}`}>
                <span className={classes.pulseDot}></span>
                {lang === "en" ? "Three.js Prototypes" : "Prototipi Three.js"}
              </span>
              <span className={`${classes.statusPill} ${classes.statusCount}`}>
                {lang === "en" ? "Porting: Godot / Unity" : "Porting: Godot / Unity"}
              </span>
            </div>
          </div>

          {/* Griglia / Lista Card Orizzontali (Row Layout) */}
          <div className={classes.gamesList}>
            {gamesData.map((game, index) => (
              <motion.article
                key={game.id}
                className={classes.gameRowCard}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: index * 0.12 }}
              >
                {/* --- COLONNA SINISTRA: Foto / Visual Preview + Slot Screenshot --- */}
                <div className={classes.visualCol}>
                  <div
                    className={classes.mainImageWrap}
                    style={game.imageBg ? { background: game.imageBg } : undefined}
                    onClick={() => openGallery(game, 0)}
                    title={lang === "en" ? "Click to view full cover" : "Clicca per ingrandire la cover"}
                  >
                    <img
                      src={game.image}
                      alt={game.title[lang] || game.title.it}
                      className={classes.mainImg}
                      style={game.imageBg ? { objectFit: "contain" } : undefined}
                    />
                    <div className={classes.imageClickHint}>
                      <FaSearchPlus />
                      <span>{lang === "en" ? "Enlarge Cover" : "Ingrandisci Cover"}</span>
                    </div>
                    <div className={classes.versionBadge}>{game.version}</div>
                    {!game.imageBg && <div className={classes.imageOverlayGradient}></div>}
                  </div>

                  {/* Slot Anteprima Screenshot (temporaneamente commentato, da riattivare successivamente) */}
                  {/*
                  <div className={classes.screenshotStrip}>
                    <div className={classes.screenshotStripLabel}>
                      <FaCamera className={classes.stripIcon} />
                      <span>{lang === "en" ? "Screenshots Preview (Click)" : "Screenshot di gioco (Clicca)"}</span>
                    </div>
                    <div className={classes.screenshotThumbs}>
                      {game.screenshots.map((shot, sIdx) => (
                        <div
                          key={shot.id}
                          className={classes.thumbSlot}
                          onClick={() => openGallery(game, sIdx + 1)}
                          title={`${shot.title} (${game.title[lang] || game.title.it}) - ${lang === "en" ? "Click to open" : "Clicca per aprire"}`}
                        >
                          <img src={shot.src} alt={shot.title} className={classes.thumbImg} />
                          <div className={classes.thumbClickHint}>
                            <FaSearchPlus />
                          </div>
                          <span className={classes.thumbIdx}>0{sIdx + 1}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  */}
                </div>

                {/* --- COLONNA DESTRA: Testi, Specifiche & Tech Stack --- */}
                <div className={classes.contentCol}>
                  <div className={classes.topMetaRow}>
                    <span className={classes.categoryBadge}>
                      <span className={classes.catIcon}>{game.icon}</span>
                      <span>{game.subtitle[lang] || game.subtitle.it}</span>
                    </span>
                    <span className={classes.statusTag}>
                      <span className={classes.pulseDot}></span>
                      <span>{game.badge[lang] || game.badge.it}</span>
                    </span>
                  </div>

                  <h2 className={classes.gameTitle}>
                    {game.title[lang] || game.title.it}
                  </h2>

                  <p className={classes.gameDesc}>
                    {game.description[lang] || game.description.it}
                  </p>

                  <div className={classes.techStackSection}>
                    <span className={classes.techStackLabel}>
                      <FaCode style={{ marginRight: 6 }} />
                      {lang === "en" ? "Engine & Stack:" : "Engine & Tecnologie:"}
                    </span>
                    <div className={classes.techPills}>
                      {game.technologies.map((tech, tIdx) => (
                        <span key={tIdx} className={classes.techPill}>
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className={classes.cardFooterRow}>
                    <span className={classes.techTagMain}>
                      <FaCube style={{ marginRight: 6 }} />
                      {game.tag}
                    </span>

                    <button className={classes.comingSoonBtn} disabled>
                      <FaLock style={{ marginRight: 8 }} />
                      <span>{lang === "en" ? "Coming Soon • In Dev" : "In Arrivo • Sviluppo"}</span>
                    </button>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>

        {/* --- LIGHTBOX MODAL PER COVER & SCREENSHOT --- */}
        <AnimatePresence>
          {activeLightbox && (
            <motion.div
              className={classes.lightboxOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.22 }}
              onClick={(e) => {
                if (e.target === e.currentTarget) setActiveLightbox(null);
              }}
            >
              {/* Header Lightbox */}
              <div className={classes.lightboxHeader}>
                <div className={classes.lightboxMeta}>
                  <div className={classes.lightboxBadgeRow}>
                    <span className={classes.lightboxBadge}>
                      {activeLightbox.images[activeLightbox.currentIndex].badge}
                    </span>
                    <span className={classes.lightboxCounter}>
                      {activeLightbox.currentIndex + 1} / {activeLightbox.images.length}
                    </span>
                  </div>
                  <h3 className={classes.lightboxTitle}>
                    {activeLightbox.images[activeLightbox.currentIndex].title}
                  </h3>
                  <p className={classes.lightboxSubtitle}>
                    {activeLightbox.images[activeLightbox.currentIndex].subtitle}
                  </p>
                </div>

                <button
                  className={classes.lightboxCloseBtn}
                  onClick={() => setActiveLightbox(null)}
                  title={lang === "en" ? "Close (Esc)" : "Chiudi (Esc)"}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Corpo Principale Lightbox con Frecce di Navigazione */}
              <div
                className={classes.lightboxBody}
                onClick={(e) => {
                  if (e.target === e.currentTarget) setActiveLightbox(null);
                }}
              >
                <button
                  className={`${classes.lightboxNavBtn} ${classes.prevBtn}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveLightbox((prev) => ({
                      ...prev,
                      currentIndex:
                        (prev.currentIndex - 1 + prev.images.length) % prev.images.length
                    }));
                  }}
                  title={
                    lang === "en"
                      ? "Previous image (Left Arrow)"
                      : "Immagine precedente (Freccia Sinistra)"
                  }
                >
                  <FaChevronLeft />
                </button>

                <motion.div
                  key={activeLightbox.currentIndex}
                  className={classes.lightboxImgWrap}
                  initial={{ opacity: 0, scale: 0.94 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.96 }}
                  transition={{ duration: 0.22 }}
                >
                  <img
                    src={activeLightbox.images[activeLightbox.currentIndex].src}
                    alt={activeLightbox.images[activeLightbox.currentIndex].title}
                    className={classes.lightboxImg}
                  />
                </motion.div>

                <button
                  className={`${classes.lightboxNavBtn} ${classes.nextBtn}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setActiveLightbox((prev) => ({
                      ...prev,
                      currentIndex: (prev.currentIndex + 1) % prev.images.length
                    }));
                  }}
                  title={
                    lang === "en"
                      ? "Next image (Right Arrow)"
                      : "Immagine successiva (Freccia Destra)"
                  }
                >
                  <FaChevronRight />
                </button>
              </div>

              {/* Thumbnail Strip Inferiore */}
              <div className={classes.lightboxFooter}>
                <div className={classes.lightboxThumbsRow}>
                  {activeLightbox.images.map((imgItem, idx) => (
                    <button
                      key={imgItem.id}
                      className={`${classes.lightboxThumbBtn} ${
                        idx === activeLightbox.currentIndex
                          ? classes.lightboxThumbActive
                          : ""
                      }`}
                      onClick={() =>
                        setActiveLightbox((prev) => ({ ...prev, currentIndex: idx }))
                      }
                      title={imgItem.title}
                    >
                      <img src={imgItem.src} alt="" className={classes.lightboxThumbImg} />
                      <span className={classes.lightboxThumbTag}>
                        {imgItem.type === "cover" ? "Cover" : `0${idx}`}
                      </span>
                    </button>
                  ))}
                </div>

                <div className={classes.lightboxHelpHint}>
                  <span>
                    {lang === "en"
                      ? "ESC: Close • ← → : Browse Images"
                      : "ESC: Chiudi • ← → : Sfoglia Immagini"}
                  </span>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        <Footer />
      </motion.main>
    </>
  );
};

export default GamePage;
